import React from 'react';
import { PrismCode } from '../../../../../components/prsimjs/Prismjs';

const CardPost = () => {
    return (
        <div id="card-post">
            <h4>Card post</h4>

            <div className="card-post-example">
                <h5>Example</h5>

                <div className="bd-example">
                    <div className="row">
                        <div className="col-6">
                            <div className="card card-post">
                                <div className="card-top position-relative">
                                    <a title="Post name" href="#card-post/action">
                                        <div className="img object-fit overflow-hidden">
                                            <div className="object-fit-cover transform-scale-h">
                                                <svg className="bd-placeholder-img card-img-top" width="100%" height="180" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
                                                    <title>Image cap</title>
                                                    <rect width="100%" height="100%"></rect>
                                                    <text x="50%" y="50%" dy=".3em">Image cap</text>
                                                </svg>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="card-body">
                                    <div className="card-meta">
                                        <p>
                                            <span>
                                                <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#card-post/action">Category</a>
                                            </span>
                                        </p>
                                    </div>

                                    <h5 className="card-title">
                                        <a title="Neque porro quisquam est qui" href="#card-post/action">Neque porro quisquam est qui</a>
                                    </h5>

                                    <div className="card-text">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="card card-post">
                                <div className="card-top position-relative">
                                    <a title="Post name" href="#card-post">
                                        <div className="img object-fit overflow-hidden">
                                            <div className="object-fit-cover transform-scale-h">
                                                <svg className="bd-placeholder-img card-img-top" width="100%" height="180" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
                                                    <title>Image cap</title>
                                                    <rect width="100%" height="100%"></rect>
                                                    <text x="50%" y="50%" dy=".3em">Image cap</text>
                                                </svg>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="card-body">
                                    <div className="card-meta">
                                        <p>
                                            <span>
                                                <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#card-post/action">Category</a>
                                            </span>
                                        </p>
                                    </div>

                                    <h5 className="card-title">
                                        <a title="Neque porro quisquam est qui" href="#card-post/action">Neque porro quisquam est qui</a>
                                    </h5>

                                    <div className="card-text">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <PrismCode
                    code={ '<div className="row">\n' +
                    '  <div className="col-6">\n' +
                    '    <div className="card card-post">\n' +
                    '      <div className="card-top position-relative">\n' +
                    '        <a title="Post name" href="#">\n' +
                    '          <div className="img object-fit overflow-hidden">\n' +
                    '            <div className="object-fit-cover transform-scale-h">\n' +
                    '              <img src="..." className="card-img-top" alt="...">\n' +
                    '            </div>\n' +
                    '          </div>\n' +
                    '        </a>\n' +
                    '      </div>\n' +
                    '      <div className="card-body">\n' +
                    '        <div className="card-meta">\n' +
                    '          <p>\n' +
                    '            <span>\n' +
                    '              <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#">Category</a>\n' +
                    '            </span>\n' +
                    '          </p>\n' +
                    '        </div>\n' +
                    '        <h5 className="card-title">\n' +
                    '          <a title="Neque porro quisquam est qui" href="#">Neque porro quisquam est qui</a>\n' +
                    '        </h5>\n' +
                    '        <div className="card-text">\n' +
                    '          <p>...</p>\n' +
                    '        </div>\n' +
                    '      </div>\n' +
                    '    </div>\n' +
                    '  </div>\n' +
                    '  <div className="col-6">\n' +
                    '    <div className="card card-post">\n' +
                    '      <div className="card-top position-relative">\n' +
                    '        <a title="Post name" href="#">\n' +
                    '          <div className="img object-fit overflow-hidden">\n' +
                    '            <div className="object-fit-cover transform-scale-h">\n' +
                    '              <img src="..." className="card-img-top" alt="...">\n' +
                    '            </div>\n' +
                    '          </div>\n' +
                    '        </a>\n' +
                    '      </div>\n' +
                    '      <div className="card-body">\n' +
                    '        <div className="card-meta">\n' +
                    '          <p>\n' +
                    '            <span>\n' +
                    '              <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#">Category</a>\n' +
                    '            </span>\n' +
                    '          </p>\n' +
                    '        </div>\n' +
                    '        <h5 className="card-title">\n' +
                    '          <a title="Neque porro quisquam est qui" href="#">Neque porro quisquam est qui</a>\n' +
                    '        </h5>\n' +
                    '        <div className="card-text">\n' +
                    '          <p>...</p>\n' +
                    '        </div>\n' +
                    '      </div>\n' +
                    '    </div>\n' +
                    '  </div>\n' +
                    '</div>'
                    }
                    language="html"
                    plugins={ ["line-numbers"] }
                />
            </div>

            <div className="card-post-sticky">
                <h5>Sticky</h5>
                <p>Add class <code>.sticky</code> to .card-post.
                </p>

                <div className="bd-example">
                    <div className="row">
                        <div className="col-6">
                            <div className="card card-post sticky">
                                <div className="card-top position-relative">
                                    <a title="Post name" href="#card-post-sticky/action">
                                        <div className="img object-fit overflow-hidden">
                                            <div className="object-fit-cover transform-scale-h">
                                                <svg className="bd-placeholder-img card-img-top" width="100%" height="180" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
                                                    <title>Image cap</title>
                                                    <rect width="100%" height="100%"></rect>
                                                    <text x="50%" y="50%" dy=".3em">Image cap</text>
                                                </svg>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="card-body">
                                    <div className="card-meta">
                                        <p>
                                            <span>
                                                <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#card-post-sticky/action">Category</a>
                                            </span>
                                        </p>
                                    </div>

                                    <h5 className="card-title">
                                        <a title="Neque porro quisquam est qui" href="#card-post-sticky/action">Neque porro quisquam est qui</a>
                                    </h5>

                                    <div className="card-text">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="card card-post sticky">
                                <div className="card-top position-relative">
                                    <a title="Post name" href="#card-post-sticky/action">
                                        <div className="img object-fit overflow-hidden">
                                            <div className="object-fit-cover transform-scale-h">
                                                <svg className="bd-placeholder-img card-img-top" width="100%" height="180" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
                                                    <title>Image cap</title>
                                                    <rect width="100%" height="100%"></rect>
                                                    <text x="50%" y="50%" dy=".3em">Image cap</text>
                                                </svg>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="card-body">
                                    <div className="card-meta">
                                        <p>
                                            <span>
                                                <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#card-post-sticky/action">Category</a>
                                            </span>
                                        </p>
                                    </div>

                                    <h5 className="card-title">
                                        <a title="Neque porro quisquam est qui" href="#card-post-sticky/action">Neque porro quisquam est qui</a>
                                    </h5>

                                    <div className="card-text">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <PrismCode
                    code={ '<div className="row">\n' +
                    '  <div className="col-6">\n' +
                    '    <div className="card card-post sticky">\n' +
                    '      <div className="card-top position-relative">\n' +
                    '        <a title="Post name" href="#">\n' +
                    '          <div className="img object-fit overflow-hidden">\n' +
                    '            <div className="object-fit-cover transform-scale-h">\n' +
                    '              <img src="..." className="card-img-top" alt="...">\n' +
                    '            </div>\n' +
                    '          </div>\n' +
                    '        </a>\n' +
                    '      </div>\n' +
                    '      <div className="card-body">\n' +
                    '        <div className="card-meta">\n' +
                    '          <p>\n' +
                    '            <span>\n' +
                    '              <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#">Category</a>\n' +
                    '            </span>\n' +
                    '          </p>\n' +
                    '        </div>\n' +
                    '        <h4 className="card-title">\n' +
                    '          <a title="Neque porro quisquam est qui" href="#">Neque porro quisquam est qui</a>\n' +
                    '        </h4>\n' +
                    '        <div className="card-text">\n' +
                    '          <p>...</p>\n' +
                    '        </div>\n' +
                    '      </div>\n' +
                    '    </div>\n' +
                    '  </div>\n' +
                    '  <div className="col-6">\n' +
                    '    <div className="card card-post sticky">\n' +
                    '      <div className="card-top position-relative">\n' +
                    '        <a title="Post name" href="#">\n' +
                    '          <div className="img object-fit overflow-hidden">\n' +
                    '            <div className="object-fit-cover transform-scale-h">\n' +
                    '              <img src="..." className="card-img-top" alt="...">\n' +
                    '            </div>\n' +
                    '          </div>\n' +
                    '        </a>\n' +
                    '      </div>\n' +
                    '      <div className="card-body">\n' +
                    '        <div className="card-meta">\n' +
                    '          <p>\n' +
                    '            <span>\n' +
                    '              <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#">Category</a>\n' +
                    '            </span>\n' +
                    '          </p>\n' +
                    '        </div>\n' +
                    '        <h4 className="card-title">\n' +
                    '          <a title="Neque porro quisquam est qui" href="#">Neque porro quisquam est qui</a>\n' +
                    '        </h4>\n' +
                    '        <div className="card-text">\n' +
                    '          <p>...</p>\n' +
                    '        </div>\n' +
                    '      </div>\n' +
                    '    </div>\n' +
                    '  </div>\n' +
                    '</div>'
                    }
                    language="html"
                    plugins={ ["line-numbers"] }
                />

            </div>


            <div className="card-post-no-thumbnail">
                <h5>No thumbnail</h5>
                <p>Add class <code>.no-thumbnail</code> to .card-post.
                </p>

                <div className="bd-example">
                    <div className="row">
                        <div className="col-6">
                            <div className="card card-post no-thumbnail">
                                <div className="card-body">
                                    <div className="card-meta">
                                        <p>
                                            <span>
                                                <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#card-post-no-thumbnail/action">Category</a>
                                            </span>
                                        </p>
                                    </div>

                                    <h5 className="card-title">
                                        <a title="Neque porro quisquam est qui" href="#card-post-no-thumbnail/action">Neque porro quisquam est qui</a>
                                    </h5>

                                    <div className="card-text">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="card card-post no-thumbnail">
                                <div className="card-body">
                                    <div className="card-meta">
                                        <p>
                                            <span>
                                                <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#card-post-no-thumbnail/action">Category</a>
                                            </span>
                                        </p>
                                    </div>

                                    <h5 className="card-title">
                                        <a title="Neque porro quisquam est qui" href="#card-post-no-thumbnail/action">Neque porro quisquam est qui</a>
                                    </h5>

                                    <div className="card-text">
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <PrismCode
                    code={ '<div className="row">\n' +
                    '  <div className="col-6">\n' +
                    '    <div className="card card-post no-thumbnail">\n' +
                    '      <div className="card-body">\n' +
                    '        <div className="card-meta">\n' +
                    '          <p>\n' +
                    '            <span>\n' +
                    '              <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#">Category</a>\n' +
                    '            </span>\n' +
                    '          </p>\n' +
                    '        </div>\n' +
                    '        <h4 className="card-title">\n' +
                    '          <a title="Neque porro quisquam est qui" href="#">Neque porro quisquam est qui</a>\n' +
                    '        </h4>\n' +
                    '        <div className="card-text">\n' +
                    '          <p>...</p>\n' +
                    '        </div>\n' +
                    '      </div>\n' +
                    '    </div>\n' +
                    '  </div>\n' +
                    '  <div className="col-6">\n' +
                    '    <div className="card card-post no-thumbnail">\n' +
                    '      <div className="card-body">\n' +
                    '        <div className="card-meta">\n' +
                    '          <p>\n' +
                    '            <span>\n' +
                    '              <a title="Category" className="btn btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space" href="#">Category</a>\n' +
                    '            </span>\n' +
                    '          </p>\n' +
                    '        </div>\n' +
                    '        <h4 className="card-title">\n' +
                    '          <a title="Neque porro quisquam est qui" href="#">Neque porro quisquam est qui</a>\n' +
                    '        </h4>\n' +
                    '        <div className="card-text">\n' +
                    '          <p>...</p>\n' +
                    '        </div>\n' +
                    '      </div>\n' +
                    '    </div>\n' +
                    '  </div>\n' +
                    '</div>'
                    }
                    language="html"
                    plugins={ ["line-numbers"] }
                />
            </div>
        </div>
    );
};

export default CardPost;
